import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'

class StudentList extends Component{
    constructor(props){
        super(props)
        this.state = {
            memberId : null
        }
    }
    handlePersonDetails = (memberId) => {
        console.log(this.props)
        this.props.history.push('/person/'+memberId)
    }

    render(){
        console.log('ini members===============================')
        console.log(this.props.members)
        return (
            <div className='shadow'>
                <table className="table table-borderless ">
                    <thead>
                        <tr>
                        <th scope="col">#</th>
                        <th scope="col">Student</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.members.map( (member, index) => {
                            return (
                                <tr key={member._id}>
                                    <td>{index+1}</td>
                                    <td>{member.name}</td>
                                    <td>
                                        <button onClick={ () => this.handlePersonDetails(member._id)} type="button" className="btn btn-dark">
                                            Details
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    </table>
            </div>
        )
    }
}

export default withRouter(StudentList)